// @flow

import styled from 'styled-components';

export const HighlightBox = styled.div`
  border: 1px solid #c5c5c5;
  border-radius: ${props => `calc(${props.theme.radius} * 0.8)`};
`;
